/* ==========================================================================
   Home Page Slider Animation
   ========================================================================== */

// ...

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { splitColor } from "gsap/all";

let split: null | SplitText = null;

function frontSlider() {
  gsap.registerPlugin(SplitText, ScrollTrigger, ScrollToPlugin);

  const container = document.getElementById("slider");
  let sections = document.querySelectorAll(".panel");
  const lastSection = document.querySelectorAll(
    ".headline-slider__slide:last-of-type"
  );
  const thirdSectionHeadline = document.querySelectorAll(
    ".headline-slider__slide:nth-child(3) h2"
  );

  if (container) {
    if (split instanceof SplitText) {
      split.revert();
    }

    split = new SplitText(".headline-slider__slide h2", {
      type: "words, chars",
      wordsClass: "headline-slider__words",
    });

    gsap.set(split.chars, { opacity: 0 });

    gsap.utils.toArray(".panel").forEach((panel, i) => {
      ScrollTrigger.create({
        trigger: panel,
        start: "top top",
        pin: true,
        pinSpacing: false,
      });
    });

    ScrollTrigger.create({
      trigger: lastSection,
      start: () => "top 60%",
      toggleClass: {
        targets: thirdSectionHeadline,
        className: "custom-hidden",
      },
    });

    ScrollTrigger.batch(split.chars, {
      onEnter: (batch) => {
        gsap.set(batch, { opacity: 1, yPercent: 100 });
        gsap.from(batch, {
          rotationX: 180,
        }),
          gsap.to(batch, {
            yPercent: 0,
            duration: 0.9,
            ease: "power4",
            stagger: 0.01,
            rotationX: 0,
          });
      },
      start: "bottom 95%",
      once: true,
    });
  }
}

function debounce(func: any) {
  var timer: any;
  return function (event: any) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 100, event);
  };
}

var frontSlideCheck = document.getElementById("headline-slider");
if (frontSlideCheck) {
  window.addEventListener("load", function () {
    frontSlider();
  });
  window.addEventListener("resize", debounce(frontSlider));
}
